import React, { useEffect, useState,useRef } from "react";
import { useSelector } from 'react-redux';
import Select from 'react-select';
import {downloadFile, getAxiosResponse, postAxiosFormDataResponse, postAxiosResponse, putAxiosResponse} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Constants from "../../../Constants";
import {dateFormat } from "../../../services/Util";
import $ from "jquery";
import SuccessMessage from "../../SuccessMessage";
import axios from "axios";
import Tooltip from "react-tooltip";
import { ToolTipIcon } from "../../../AppIcons";
import { ConditionalBlock } from '../../../ConditionalBlock';
import { RotatingLines } from "react-loader-spinner";
import dateUtil, {DATE_FORMATS} from "../../../services/DateUtil";


const chunkSize = Constants.CHUNK_SIZE;

export default function DiscussionDetails(prop) {
    const projectId = prop.id;
    const topicId = prop.topicId;
    const [notifyUsers, setNotifyUsers] = useState([]);
    const [followers,setFollowers] = useState([]);
    const [showEdit,setShowEdit] = useState(false);
    const [topic,setTopic] = useState({});
    const [date,setDate] = useState("");
    const [followersName, setFollowersName] = useState("");
    const [vendor, setVendor] = useState("");
    const [showRemoveMe, setRemoveMe] = useState(false);
    const [showNotificationUsers, setShowUsers] = useState([]);
    const [dateWiseResponse,setDateWiseResponse] = useState([]);
    const [chatText,setChatText] = useState("");
    const [refreshPage,setRefreshPage] = useState(false);
    const [successMsg, setSuccessMsg] = useState(Constants.BLANK);
    const [message, setMessage] = useState(Constants.BLANK);
    const [selectedfile, setSelectedFile] = useState("");
    const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [documentFileId, setDocumentFileId] = useState(-1);
    const [isFollowing, setIsFollowing] = useState(false);
    const [showLoader,setShowLoader] = useState(true);
    const [pending,setPending] = useState(false);
    const [loadingTopicDetails, setLoadingTopicDetails] = useState(true);
    const[filesize,sefilesize]=useState("")

    const owner = useSelector(
        (loginSessionDetail) => loginSessionDetail.loginSession
    ).value
    const custBootstrapDataRedux = useSelector(
        (store) => store.customer_bootstrap_data
      ).value;
    const backToList = () =>{
        prop.toggleTopicList(false);
    }

    useEffect(()=>{
        $(".success-message").attr("id","editMsg");
        if(successMsg!==Constants.BLANK){
          setTimeout(function(){
            setSuccessMsg(Constants.BLANK);
          },5000);
          
        }
   },[successMsg]);
   useEffect(()=>{
    $('.backFocus').trigger('focus')
   },[])

    useEffect(()=>{
        let messages = dateWiseResponse;
        let date = dateUtil.format(new Date());
        if(messages[date]){
            let chats = messages[date];
            chats.push(message);
        }else{
            messages[date] = [message];
        }
        setDateWiseResponse(messages);
        scrollSmoothlyToBottom("main-chat");
    },[message]);

    useEffect(() => {
        if(!showEdit){
            fetchDiscussion();
            fetchMembers();
        }else{
            fetchMembers();
        }
        scrollSmoothlyToBottom("main-chat");
    }, [showEdit,refreshPage]);

    useEffect(() => {
        const isOwnerFollowing = showNotificationUsers.some((user) => user.value === owner.id);
        setIsFollowing(isOwnerFollowing);
      }, [showNotificationUsers])

    const fetchDiscussion = () => {
        getAxiosResponse(APIUrls.CAMPAIGN_TOPIC_BY_ID(projectId,topicId))
        .then((res) => {
            if (res.data.code === 200) {
                const topic = res?.data?.data;
               const filesize= res?.data?.data.attachment.sizeInKilobytes
                sefilesize(filesize)
                setTopic(topic);
                setDate(dateUtil.format(topic.createdDate, DATE_FORMATS.DATE_TIME));
                let followerName = "";
                let vendor = "";
                const users = topic.followers.filter((o)=>(o.customerUser))
                    .map((o)=>{
                        if(o.customerUser.userId === owner.id){
                            setRemoveMe(true);
                        }
                        if(followerName!==""){
                            followerName += `, ${o.customerUser.firstName} ${o.customerUser.lastName}`;
                        }else{
                            followerName = `${o.customerUser.firstName} ${o.customerUser.lastName}`;
                        }
                        let roleName = o.customerUser.roleSet.displayName?.split(',')[0];
                        return ({label:`${o.customerUser.firstName} ${o.customerUser.lastName} (${roleName})`,value:o.customerUser.userId,isVendor:false})
                    });
                topic.followers.filter((o)=>(o.vendor))
                    .forEach((o)=>{
                        if(vendor!==""){
                            vendor += `, ${o.vendor.name}`;
                        }else{
                            vendor = `${o.vendor.name}`;
                        }
                        users.push({value:o.vendor.id,label:o.vendor.name,isVendor:true});
                    });
                if(vendor){
                    followerName = `${vendor}, ${followerName}`;
                }
                let messages = [];
                let dateWiseMessages = {};
                topic.responses.map((response)=>{
                    let date = dateUtil.format(response.createdDate);
                    let message = {
                        id:response.id,
                        isCreator:response.creatorUser.userId === owner.id,
                        text:response.text,
                        createdDate:response.createdDate,
                        time: dateUtil.format(response.createdDate, DATE_FORMATS.TIME_OF_DAY),
                        initials:getNameInitials(response.creatorUser),
                        attachment:response.attachment,
                        creatorName:`${response.creatorUser.firstName} ${response.creatorUser.lastName}`         
                    };
                    if(dateWiseMessages[date]){
                        let messages = dateWiseMessages[date];
                        messages.push(message);
                    }else{
                        dateWiseMessages[date] = [message];
                    }
                });
                setDateWiseResponse(dateWiseMessages);
                setShowUsers(users);
                setFollowersName(followerName);
                setVendor(vendor);
                setLoadingTopicDetails(false);
            }
        }).catch((err) => {
            console.error(err);
        });
        setShowLoader(false);
    };
    
    const removeMe = ()=>{
        let topic1 = {
            id:topicId,
            followers:[]
        };
        let data = [];
        topic.followers.forEach((o)=>{
            if(o.vendor){
                data.push({vendor:{id:o.vendor.id,name:o.vendor.name}});
            }else{
                if(o.customerUser.userId!==owner.id){
                    data.push({customerUser:{userId:o.customerUser.userId}});
                }
            }
        })
        topic1.followers=data;
        updateTopic(topic1,false);
     };

    const addMe = ()=>{
        let topic1 = {
            id:topicId,
            followers:[]
        };
        let data = [{customerUser:{userId:owner.id}}];
        topic.followers.forEach((o)=>{
            if(o.vendor){
                data.push({vendor:{id:o.vendor.id,name:o.vendor.name}});
            }else{
                data.push({customerUser:{userId:o.customerUser.userId}});
            }
        });
        topic1.followers=data;
        updateTopic(topic1,true);
        
    };

    const updateTopic = (topic,removeMe)=>{
        putAxiosResponse(APIUrls.CAMPAIGN_TOPIC_BY_ID(projectId,topic.id),topic)
        .then((response)=>{
            if(response.data?.code===200){
                setRemoveMe(removeMe);
                setRefreshPage(refreshPage?false:true);
                setSuccessMsg("Changes done successfuly")
                setTimeout(function(){
                     $('.afterSuccessFocus').trigger('focus')
                },4000);
            }
        }).catch((err)=>{
            console.error(err);
        });
    };

    const fetchMembers = ()=>{
        getAxiosResponse(APIUrls.CAMPAIGN_MEMBERS(projectId))
        .then((response)=>{
            let members = response.data.data;
            let followers = [];
            let data = [{label:"-- Select All Campaign Members-- ",value:"all"}];
            members.forEach((val)=>{
                let user = showNotificationUsers.filter((obj)=> obj.value === val.customerUser.userId);
                if(user.length===0){
                    data.push({label:getInitials(val.customerUser),value:val.customerUser.userId})
                }
                followers.push({label:getInitials(val.customerUser),value:val.customerUser.userId});
            });
            setFollowers(followers);
            setNotifyUsers(data);
        }).catch((err)=>{
            console.error(err);
        })
    };

    const getInitials=(user)=>{
        return `${user.firstName} ${user.lastName}(${user.roleSet.displayName})`;
    }

    const showModal = () =>{
        showEdit ? setShowEdit(false) : setShowEdit(true);
        const btn = $("#confirm-btn");
        if(!btn.hasClass("disabled-data")){
            btn.add("disabled-data");
        }
      setTimeout(() => {
          document.body.classList.add("gb-modal-open");
       }, 200);
       setTimeout(() => {
        $(".first-focus").trigger("focus");
        $("#focusSelect .cw__input").on("keydown", function (e) {
          if (e.key === Constants.TAB) {
           if (e.shiftKey === true) {
              e.preventDefault();
              $("#confirm-btn").trigger("focus");
            }
          }
        });
        $(".inner-lightbox-panel").on("keydown", function (e) {
          if (e.key === Constants.ESCAPE) {
            hideModel();
           }
        });
      }, 500);
    };
    
    const handleKeyEditflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#focusSelect .cw__input").trigger("focus");
          }
        }
      };

    const hideModel = ()=>{
        showEdit ? setShowEdit(false) : setShowEdit(true);
        document.body.classList.remove("gb-modal-open");
        $('.editFocus').trigger('focus')
        };

    const removeItem = (user) => {
        enableConfirmButton();
        setShowUsers((current) =>
          current.filter(
            (showNotificationUsers) => showNotificationUsers.value !== user.value
          )
        );
        setNotifyUsers((current) => [...current,user]);
        const selectedElement = $(document.activeElement).closest(".multiselect-output");
        if($(document.activeElement).is(':last-child') &&
        selectedElement.children().length > 1){
            selectedElement.find('button:nth-last-child(2)').trigger('focus');
        } else if($(document.activeElement).is(':last-child')){
        $(document.activeElement).closest(".lightbox-content").find('.global-dropdown-block input:first-of-type').trigger('focus');
        }
    };

    const enableConfirmButton = ()=>{
        const btn = $("#confirm-btn");
        if(btn.hasClass("disabled-data")){
            btn.removeClass("disabled-data")
        }
    };

    const handleNotifyUserChange = (event) => {
        let selectedId = event.value;
        if(event.value === "all"){
            setShowUsers(followers);
            let leftover = notifyUsers.filter(({value})=> (value === "all"));
            setNotifyUsers(leftover);
        }else {
            let result = notifyUsers.find(({ value }) => value == selectedId);
            setShowUsers(current => [...current, result]);
            let rest = notifyUsers.filter(({ value }) => value !== selectedId);
            setNotifyUsers(rest);
        }
        enableConfirmButton();
    };

    const updateFollowers = ()=>{
        let topic1 = {
            id:topicId,
            followers:[]
        };
        const folloerIds = showNotificationUsers.map((o)=>{
                return ({customerUser:{userId:o.value}});
        });
        topic1.followers = folloerIds;
        putAxiosResponse(APIUrls.CAMPAIGN_TOPIC_BY_ID(projectId,topic1.id),topic1)
        .then((response)=>{
            if(response.data?.code===200){
               setSuccessMsg("Followers updated.")
                setTimeout(() => {
                hideModel();
                }, 100);
                setTimeout(() => {
                    $('.editFocus').trigger('focus')
                 }, 5000);
            }
    
        }).catch((err)=>{
            console.error(err);
        });
        
    };

    const LeftChat = (props)=>{
        const message = props.message;
        return(
            <div className='left-chat-msg flex'>
                <div className='chat-user-name'>
                    <span>{message.initials}</span>
                </div>
                <div className='user-chat-text'>
                    <div className='time flex-center'>
                        <strong>{message.creatorName}</strong>
                        <span>{message.time}</span>
                    </div>
                    <div className='chat-bubble-list'>
                        <div className='chat-bubble'>
                            {message.text}
                        </div>
                    </div>
                    {message.attachment?<MessageAttachment attachment={message.attachment} responseId={message.id} />:Constants.BLANK}
                </div>
            </div>
        );
    };

    const MessageAttachment = (prop)=>{
        const attachment = prop.attachment;
        const responseId = prop.responseId;
        return(
            <>
                <div className="chat-attach-text">
                    <a tabIndex="0" role="button" aria-label={"download " + `${attachment.filename}`}
                     onClick={()=>downloadMessageAttachment(attachment.filename,responseId)}
                     onKeyDown={(e)=>EnterdownloadMessageAttachment(e,attachment.filename,responseId)}
                     >
                        {`${attachment.filename}`}
                    </a>
                    <button id="masterDocTooltip" aria-label="tooltip" className="p-5 0 tooltipContainer sourceTooltipFocus" data-tip data-place="right" data-for="source-file-content-0">
                        {ToolTipIcon}
                    </button>
                    <Tooltip className="extraClass" id="source-file-content-0" delayHide={1000} effect="solid" >
                        <div className="react-innerTooltip">
                        <ul>
                            <li> <strong>Size</strong>
                            </li>
                            <li>{attachment.sizeInKilobytes} KB</li> 
                            <ConditionalBlock condition={attachment?.fileContents}>
                                <li> <strong>File included in this ZIP:</strong></li>
                                <li>{attachment?.fileContents}</li> 
                            </ConditionalBlock>
                            </ul>
                        </div>
                    </Tooltip> 
                </div>
            </>
        );
    };

    const RightChat = (props) =>{
        const message = props.message;
        return(
            <div className='right-chat-msg flex'>
                    <div className='user-chat-text'>
                        <div className='time flex-center'>
                            <span>{message.time}</span>
                            <strong>{message.creatorName}</strong>
                        </div>
                        <div className='chat-bubble-list'>
                            <div className='chat-bubble'>
                                {message.text}
                            </div>
                        </div>
                        {message.attachment?<MessageAttachment attachment={message.attachment} responseId={message.id} />:Constants.BLANK}
                    </div>
                    <div className='chat-user-name'>
                        <span>{message.initials}</span>
                    </div>
            </div>
        );
    };
    
    const sendMessage = ()=>{
        if(chatText!==Constants.BLANK){
            const message = {
                text:chatText,
                time:"now",
                initials:getNameInitials(owner),
                creatorName:`${owner.firstName} ${owner.lastName}`,
                isCreator:true
            };
            setMessage(message);
            sendMessageToTopic();
        }
    };

    const setChatTextValue = (e)=>{
        setChatText(e.target.value);
    };

    const sendMessageOnEnter = (e)=>{
        if(e.keyCode ===13){
            sendMessage();
        }
    }

    const sendMessageToTopic = ()=>{
        const params = getParams();
        createTopicResponseMetaData(params);
    };

    const getParams = () =>{
        let params = new URLSearchParams();
        params.set("workspaceId",projectId);
        params.set("topicId",topicId);
        params.set("text",chatText);
        if(selectedfile){
            params.set("name", selectedfile.name);
            params.set("size", selectedfile.size);
            params.set("currentChunkIndex", currentChunkIndex);
            params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
            params.set("fileDataAttribute","attachment.fileData");
            params.set("attachment.filename",selectedfile.name);
            params.set("attachment.sizeInKilobytes",selectedfile.size);
        }
        params.set("hasDocument", selectedfile?true:false);
        params.set("documentFileId",(documentFileId!==-1)?documentFileId:"");
        return params;
    };

    const downloadAttachment = (fileName)=>{
        const url = APIUrls.CAMPAIGN_TOPIC_ATTACHMENT(projectId,topicId);
        downloadFile(url,fileName);
    };

    const downloadMessageAttachment = (fileName,responseId)=>{
        const url = APIUrls.CAMPAIGN_TOPIC_MESSAGE_ATTACHMENT(projectId,topicId,responseId);
        downloadFile(url,fileName);
    }
    const EnterdownloadMessageAttachment = (event,fileName,responseId)=>{
        if (event.key === Constants.ENTER) {
          const url = APIUrls.CAMPAIGN_TOPIC_MESSAGE_ATTACHMENT(projectId,topicId,responseId);
          downloadFile(url,fileName);
        }
    }
    const fileSelection = (e)=> {
        if (e.target) {
            setSelectedFile(e.target.files[0]);
            $("#chat-area").removeClass("conditional-width")
        }else{
            $("#chat-area").addClass("conditional-width");
        }
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return "0 Bytes";
        const k = 1024;
        let dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        let i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    };

    useEffect(()=>{
        if(currentChunkIndex !== -1){
          readAndUploadCurrentChunk();
        }
    },[currentChunkIndex]);
          
    const readAndUploadCurrentChunk=()=> {
        const file = selectedfile;
        if (file) {
          const reader = new FileReader();
          const from = currentChunkIndex * chunkSize;
          const to = from + chunkSize;
          const blob = file.slice(from, to);
          reader.onload = (e) => uploadChunk(e);
          reader.readAsDataURL(blob);
        }else{
          uploadChunk(null);
        }
    };

    const uploadChunk=(readerEvent) =>{
        const file = selectedfile;
        const data = readerEvent ? readerEvent.target.result : {};
        const headers = {
          "Content-Type": "application/octet-stream",
          "CSRF-Token": localStorage.getItem("csrfToken"),
        };
        let params = getParams();
        const urlPart = (file ? APIUrls.CAMPAIGN_TOPIC_CREATE_MESSAGE : APIUrls.CAMPAIGN_TOPIC_CREATE_MESSAGE.replace("/upload",""))+"?"+params.toString();
        const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
        axios.post(url, data, { headers }).then((response)=>{
            if(response?.data?.code === 200){
                if(selectedfile){
                    const filesize = selectedfile.size;
                    const chunks = Math.ceil(filesize / chunkSize) - 1;
                    const isLastChunk = currentChunkIndex === chunks;
                    if (isLastChunk) {
                        setCurrentChunkIndex(-1);
                        setFileUploadProgress(100);
                        setRefreshPage(refreshPage?false:true);
                        setChatText("");
                        setSelectedFile("");
                        $("#chat-area").addClass("conditional-width");
                        setPending(false);
                    } else {
                        const chunks = Math.ceil(filesize / chunkSize);
                        setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
                        setCurrentChunkIndex(currentChunkIndex + 1);
                    }
                }else{
                    setCurrentChunkIndex(-1);
                    setRefreshPage(refreshPage?false:true);
                    setChatText("");
                    setSelectedFile("");
                    $("#chat-area").addClass("conditional-width");
                    setPending(false);
                }
            }
        });
      };

    const createTopicResponseMetaData = (params)=>{
        let url = `${APIUrls.CAMPAIGN_TOPIC_CREATE_MESSAGE_METADATA}`;
        setPending(true);
        postAxiosFormDataResponse(url,params)
        .then((response)=>{
            if(response?.data?.code === 200){
                if (response?.data?.data) {
                    setDocumentFileId(response?.data?.data);
                    setCurrentChunkIndex(0);
                }else{
                    setCurrentChunkIndex(0);
                }
            }
        }).catch((err)=>{
            console.error(err);
        });
    };

    const getNameInitials = (user)=>{
        return `${user.firstName?.charAt(0)?.toUpperCase()}${user.lastName?.charAt(0)?.toUpperCase()}`;
    };

    const scrollSmoothlyToBottom = (id) => {
        const element = $(`#${id}`);
         element.animate({
           scrollTop: element.prop("scrollHeight")
        }, 500);
    };

    return (
    <>
        <ConditionalBlock condition={showLoader === false}>
            <div className="campaign_details-task-create-form">
                <div className="projects-heading">
                <h5>{topic.subject}</h5>
                <button className="btn-bold backFocus" onClick={backToList}>Back</button>
                </div>
                <div className="discussion-outer">
                    <div className="left">
                        <div className="discussion-table">
                            <ul>
                                <li>
                                    <div className="title">Date</div>
                                    <div className="relative text">
                                        <span className="font-zero setFastpass" aria-label={date}>
                                            {date}
                                        </span>
                                        <span aria-hidden="true">{date}</span>
                                    </div>
                                    
                                </li>
                                <li>
                                    <div className="title">From</div>
                                    <div className="text">{topic.creatorDisplayName}</div>
                                </li>
                                <li>
                                    <div className="title">Notifications will be sent to</div>
                                    <div className="text">
                                        <p>{followersName}</p>
                                        <div className="btn-wrap btn-gap align-items">
                                            <button aria-describedby="editMsg" className="inline-flex editFocus" onClick={showModal}>Edit</button>
                                            {showRemoveMe && isFollowing ?<button className="inline-flex afterSuccessFocus"  onClick={removeMe}>Remove Me </button>:<button   className="inline-flex afterSuccessFocus" onClick={addMe}>Add Me</button>}
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="title">Who will have access to this discussion?</div>
                                    <div className="text">{vendor!==Constants.BLANK? vendor+", Your internal company users" :"Your internal company users"}</div>
                                </li>
                                <li>
                                    <div className="title">Discussion</div>
                                    {loadingTopicDetails
                                      ? (<div className="text">Loading...</div>)
                                      : topic.text && (<div className="text discussion-topic-text">{topic.text.split("\n").map(line => (<>{line}<br></br></>))}</div>)}
                                </li>
                                {topic.attachment?
                                    <li>
                                        <div className="title">Attachment</div>
                                        <a className="attach-breakText" onClick={()=>downloadAttachment(topic.attachment?.filename)}>
                                            {topic.attachment?.filename}
                                        </a>
                                        <button id="masterDocTooltip" aria-label="tooltip" className="p-5 0 tooltipContainer sourceTooltipFocus" data-tip data-place="right" data-for="source-file-content-1"  >
                                            {ToolTipIcon}            
                                        </button>
                                        <Tooltip className="extraClass" id="source-file-content-1" delayHide={1000} effect="solid" >
                                            <div className="react-innerTooltip">
                                                <ul>
                                                    <li> <strong>Size</strong> </li>
                                                    <li>{topic.attachment?.sizeInKilobytes} KB</li> 
                                                    <ConditionalBlock condition={topic.attachment?.fileContents}>
                                                        <li><strong>Files included in this ZIP:</strong></li>
                                                        <li>{topic.attachment?.fileContents}</li>
                                                    </ConditionalBlock>
                                                </ul>
                                            </div>
                                        </Tooltip> 
                                    </li>
                                :Constants.BLANK
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="right chatbox-block">
                        <ConditionalBlock condition={pending === false}>
                            <div id="main-chat" className='main-chatbox-container'>
                            {
                                Object.entries(dateWiseResponse).map((k,i)=>{
                                    return (
                                    <>
                                        <div className='date-line' key={i}>
                                            <span>{k[0]}</span>
                                        </div>
                                        {k[1].map((message,index)=>{
                                            return ((message.isCreator)
                                                        ?<RightChat message = {message} key={index}/> 
                                                        : <LeftChat message = {message} key={index}/>);
                                        })
                                        }
                                    </>
                                    )
                                })
                            }
                            </div>
                        </ConditionalBlock>
                        <ConditionalBlock condition={pending === true}>
                            <div style={{ textAlign: "center" }}>
                                <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true} />
                            </div>
                        </ConditionalBlock>
                        <div id="chat-area" className="chat-inputarea conditional-width flex">
                            <div className="chat-icon flex-center btn-gap">
                                <div className="attachment-icon">
                                    <input type="file" id="chat-file" onChange={fileSelection} />
                                    <label htmlFor="chat-file" aria-label="choose file">
                                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                            <path d="M12.4966 6.0589L11.216 4.85666L4.81261 10.8726C4.56042 11.1097 4.36039 11.3911 4.22394 11.7008C4.08749 12.0105 4.01729 12.3424 4.01735 12.6776C4.01741 13.0128 4.08773 13.3447 4.22428 13.6543C4.36084 13.964 4.56097 14.2454 4.81324 14.4823C5.06551 14.7193 5.36498 14.9073 5.69456 15.0355C6.02413 15.1637 6.37736 15.2297 6.73406 15.2296C7.09077 15.2296 7.44397 15.1635 7.7735 15.0352C8.10303 14.9068 8.40244 14.7188 8.65462 14.4817L16.3387 7.26234C17.1876 6.46441 17.6645 5.38226 17.6644 4.25393C17.6643 3.12561 17.1872 2.04354 16.338 1.24577C15.4889 0.448007 14.3373 -0.000111155 13.1365 2.06817e-08C11.9358 0.000111197 10.7843 0.448443 9.9353 1.24637L1.8677 8.8262L1.85003 8.84162C-0.616678 11.1596 -0.616678 14.9157 1.85003 17.2324C4.31675 19.5492 8.31395 19.5492 10.7807 17.2324L10.7971 17.2158L10.7983 17.217L16.3058 12.0429L15.0252 10.8406L9.51766 16.0136L9.50126 16.029C8.65606 16.8217 7.51072 17.2668 6.31661 17.2668C5.1225 17.2668 3.97716 16.8217 3.13197 16.029C2.71302 15.6345 2.38107 15.1661 2.15514 14.6508C1.92922 14.1354 1.81377 13.5832 1.81541 13.0259C1.81705 12.4685 1.93575 11.9169 2.16471 11.4028C2.39366 10.8886 2.72837 10.422 3.14963 10.0296L3.14837 10.0284L11.2172 2.44861C12.2758 1.45267 13.9994 1.45267 15.0592 2.44861C16.1191 3.44456 16.1178 5.06296 15.0592 6.05772L7.37522 13.2771C7.20325 13.4258 6.97683 13.5062 6.74323 13.5017C6.50963 13.4972 6.28693 13.408 6.12163 13.2528C5.95634 13.0977 5.86124 12.8885 5.85619 12.669C5.85114 12.4495 5.93654 12.2366 6.09454 12.0749L12.4979 6.05772L12.4966 6.0589Z" fill="#6B7C93"></path>
                                        </svg>
                                    </label>
                                </div>
                                <div id="file-name" className="file-text">
                                    <span className="ext-name" title={selectedfile?.name}>{selectedfile?.name}</span>
                                    <span className="file-size">
                                        {selectedfile?.size}
                                    </span>
                                </div>
                            </div>
                            <div className='right-chat-input'>
                                <input type="text" className="msger-input" placeholder="Add a comment..." value={chatText} onChange={e=>setChatTextValue(e)} onKeyDown={(e)=>{sendMessageOnEnter(e)}}/>
                                <button type="submit" aria-label="send message" className='chat-send-btn' onClick={sendMessage}>
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M8.64233 9.99984H3.49254L1.77042 3.44567C1.7594 3.40758 1.75268 3.36847 1.75039 3.329C1.73123 2.72817 2.42286 2.3115 3.02216 2.5865L19.1719 9.99984L3.02216 17.4132C2.42983 17.6857 1.74691 17.2807 1.75039 16.6907C1.75215 16.638 1.76183 16.5858 1.77913 16.5357L3.057 12.4998" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="model-popup" className="lightbox-panel discussion-popup bid-extended" aria-labelledby="addRecipients" role="dialog">
                    <div className="inner-lightbox-panel">
                        <div className="modal-header flex">
                            <strong id="addRecipients">Add Recipients to Discussion</strong>
                        </div>
                        <div className="lightbox-content overflow-inherit">
                            <div id="focusSelect" className="global-dropdown-block flex-column mar-bot10">
                                <label>Add Recipients</label>
                                <Select className="global-dropdown-select" classNamePrefix='cw'
                                placeholder="-- Add Recipients -- "
                                aria-label="Add Recipients"
                                options={notifyUsers}
                                onChange={e => handleNotifyUserChange(e)}
                                />
                            </div>
                            <div className="multiselect-output flex">
                                {showNotificationUsers.map((user,index) => {
                                    return (
                                    <button key={index} aria-label={"remove " + user.label }  onClick={() => removeItem(user)}>
                                            <strong>
                                                {user.label}
                                            </strong>
                                            {user.isVendor?'':
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none" 
                                        >
                                                <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                            </svg>}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>	
                        <div className="modal-footer flex">
                            <button className="btn btn-bold first-focus" onClick={hideModel}>Cancel</button>
                            <button id="confirm-btn" className="btn btn-bold active disabled-data" onKeyDown={handleKeyEditflow}
                            onClick={updateFollowers}>Confirm</button>
                        </div>
                    </div>		
                </div>
            </div>
        </ConditionalBlock>
        {(successMsg!==undefined && successMsg !== Constants.BLANK)?<SuccessMessage message={successMsg}/>:Constants.BLANK}
        <ConditionalBlock condition={showLoader === true}>
            <div style={{ textAlign: "center" }}>
                <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true} />
            </div>
        </ConditionalBlock>
    </>
  )
};
